export const SERVER_URL = process.env.REACT_APP_SERVER_URL
export const BASE_FINANCE_API_URL = process.env.REACT_APP_FINANCE_SERVER_URL
export const SERVERLESS_URL = process.env.REACT_APP_SERVERLESS_URL
